'use client'
import styled from 'styled-components'
import { Row } from '@shipt/design-system-layouts'
import { MenuIcon } from '@shipt/design-system-icons'
import { IconButton } from '@shipt/design-system-buttons'
import { screenSizes } from '@shipt/design-system-themes'
import { GridLayoutContainer } from '@/features/shared/styles/layout'
import { HeaderLogoLink } from '@/features/shared/components/Headers/HeaderLogoLink'
import { HeaderUserLinks } from '@/features/shared/components/Headers/HeaderUserLinks'
import { useHandleDialog } from '@/features/shared/state/Dialog/useHandleDialog'
import { DynamicFullSizeMobileMenuModal } from '@/features/shared/components/Modal/FullSizeMobileMenuModal/DynamicFullSizeMobileMenuModal'
import { MobileMenu } from '@/features/shared/components/Headers/UngatedHeader/MobileMenu'
import { UngatedHeaderLinks } from '@/features/shared/components/Headers/UngatedHeader/UngatedHeaderLinks'
import { shadow2 } from '@/features/shared/styles/effects'

export const UngatedHeaderContent = () => {
  const { openDialog, closeDialog } = useHandleDialog()

  return (
    <GridLayoutContainer contentMaxWidth>
      <Nav className="fullWidth contentAtTablet">
        <Row align="center" spacing={{ base: 'sm', lg: 'xl' }}>
          <MenuButton
            icon={MenuIcon}
            size="md"
            variant="ghost"
            onClick={() =>
              openDialog(DynamicFullSizeMobileMenuModal, {
                renderMenu: () => <MobileMenu onClose={closeDialog} isGlobalMenu />,
              })
            }
            aria-label="Main menu"
          />
          <HeaderLogoLink />
          <UngatedHeaderLinks />
        </Row>
        <HeaderUserLinks linkSize={{ base: 'sm', md: 'md' }} />
      </Nav>
    </GridLayoutContainer>
  )
}

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
  height: 4.5rem;
  padding: 0 1.25rem;

  @media ${screenSizes.tablet} {
    padding: 0;
  }
`

const MenuButton = styled(IconButton)`
  @media ${screenSizes.smDesktop} {
    display: none;
  }
`

export const UngatedHeaderWithShadow = ({ sticky = true }: { sticky?: boolean }) => {
  return (
    <HeaderWrapper data-sticky={sticky}>
      <UngatedHeaderContent />
    </HeaderWrapper>
  )
}

const HeaderWrapper = styled.header<{ 'data-sticky'?: boolean }>`
  ${shadow2};
  background-color: ${({ theme }) => theme.white};

  &[data-sticky='true'] {
    position: sticky;
    top: 0;
    z-index: 999;
  }
`
